import { render, staticRenderFns } from "./Vfd.vue?vue&type=template&id=62ef645c&scoped=true&"
import script from "./Vfd.vue?vue&type=script&lang=js&"
export * from "./Vfd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef645c",
  null
  
)

export default component.exports